import { useState } from 'react';

// Click-to-edit cell for the branches grid. SAFE scalar fields ONLY — never
// taxId/branchCode/bank (spec §15: bank is M7; identity fields are immutable here).
export const SAFE_BRANCH_FIELDS = ['terms', 'defaultExpenseCode', 'email', 'isActive'] as const;
export type SafeBranchField = (typeof SAFE_BRANCH_FIELDS)[number];

export function isSafeField(field: string): field is SafeBranchField {
  return (SAFE_BRANCH_FIELDS as readonly string[]).includes(field);
}

export function InlineEditCell({
  field,
  value,
  onCommit,
  disabled,
}: {
  field: SafeBranchField;
  value: string | null;
  onCommit: (field: SafeBranchField, next: string) => void;
  disabled?: boolean;
}) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(value ?? '');
  if (!isSafeField(field)) return <span>{value ?? '—'}</span>; // defensive — never editable

  function commit() {
    setEditing(false);
    if (draft !== (value ?? '')) onCommit(field, draft);
  }
  if (!editing) {
    return (
      <span
        role="button"
        tabIndex={0}
        style={{
          cursor: disabled ? 'default' : 'text',
          borderBottom: disabled ? 'none' : '1px dashed var(--border-strong)',
        }}
        onClick={() => {
          if (disabled) return;
          setDraft(value ?? '');
          setEditing(true);
        }}
      >
        {value ?? <span className="muted">—</span>}
      </span>
    );
  }
  return (
    <input
      className="input"
      autoFocus
      value={draft}
      style={{ width: '100%' }}
      onChange={(e) => setDraft(e.target.value)}
      onBlur={commit}
      onKeyDown={(e) => {
        if (e.key === 'Enter') commit();
        if (e.key === 'Escape') setEditing(false);
      }}
    />
  );
}
